import React, { useContext } from 'react';
import { HDAccessProvider, } from '@ocm_customer/account_pro-ui-access';
import { Alert, Typography } from '@one-thd/sui-atomic-components';
import { ExperienceContext } from '@thd-nucleus/experience-context';
import { CustomerAccountNavigation } from '@thd-olt-component-react/customer-account-navigation';
import { QueryProvider } from '@thd-nucleus/data-sources';
import { useLeftNavData } from '@ocm_customer/account_navigation';
import { Breadcrumbs } from './Breadcrumbs';
import { useInterceptors } from '../../hooks/use-interceptors';
export var PageLayout = function (props) {
    var _a;
    var children = props.children, crumbs = props.crumbs, customerRole = props.customerRole, customerType = props.customerType, headerComponent = props.headerComponent, pageTitle = props.pageTitle;
    var redirectError = useInterceptors().redirectError;
    var _b = useLeftNavData(), policies = _b.policies, trials = _b.trials, userState = _b.userState, enrollments = _b.enrollments;
    var configService = useContext(ExperienceContext).configService;
    var ENABLE_NEW_ADDRESS_PAGE = configService.ENABLE_NEW_ADDRESS_PAGE, ENABLE_NEW_PROGRAM_DETAILS_PAGE = configService.ENABLE_NEW_PROGRAM_DETAILS_PAGE, ENABLE_NEW_PROXTRA_PRICING_PAGE = configService.ENABLE_NEW_PROXTRA_PRICING_PAGE, ENABLE_NEW_PAYMENTS_PAGE = configService.ENABLE_NEW_PAYMENTS_PAGE, ENABLE_NEW_ADDMANAGE_USERS = configService.ENABLE_NEW_ADDMANAGE_USERS, ENABLE_NEW_PURCHASE_HISTORY_PAGE = configService.ENABLE_NEW_PURCHASE_HISTORY_PAGE, ENABLE_NEW_EMAIL_PREFERENCE_LINK = configService.ENABLE_NEW_EMAIL_PREFERENCE_LINK, ENABLE_NUCLEUS_QUOTE_EXPERIENCE = configService.ENABLE_NUCLEUS_QUOTE_EXPERIENCE;
    // TODO Move this to its a constants file
    var features = {
        isAddressCustUserSwitchEnabled: true,
        isQBOnlineEnabled: true,
        isInstantCheckoutEnabled: true,
        isPOJobNamesEnabled: true,
        isAddUsersLinkEnabled: true,
        isWorkflowEnabled: true,
        isRunnerAllowanceEnabled: true,
        isKeyTagsEnabled: true,
        isDefaultAgreementCodeEnabled: true,
        isCitiSsoEnabled: true,
        ENABLE_NEW_ADDRESS_PAGE: ENABLE_NEW_ADDRESS_PAGE === '1',
        ENABLE_NEW_EMAIL_PREFERENCE_LINK: ENABLE_NEW_EMAIL_PREFERENCE_LINK === '1',
        ENABLE_NEW_PROGRAM_DETAILS_PAGE: ENABLE_NEW_PROGRAM_DETAILS_PAGE === '1',
        ENABLE_NEW_PROXTRA_PRICING_PAGE: ENABLE_NEW_PROXTRA_PRICING_PAGE === '1',
        ENABLE_NEW_PAYMENTS_PAGE: ENABLE_NEW_PAYMENTS_PAGE === '1',
        ENABLE_NEW_PURCHASE_HISTORY_PAGE: ENABLE_NEW_PURCHASE_HISTORY_PAGE === '1',
        ENABLE_NEW_ADDMANAGE_USERS: ENABLE_NEW_ADDMANAGE_USERS === '1',
        ENABLE_NUCLEUS_QUOTE_EXPERIENCE: ENABLE_NUCLEUS_QUOTE_EXPERIENCE === 'true',
    };
    var user = {
        role: (customerRole || '').toUpperCase(),
        type: (customerType || '').toUpperCase(),
        isMemberOfHierarchyOrg: !!((_a = userState === null || userState === void 0 ? void 0 : userState.customer) === null || _a === void 0 ? void 0 : _a.hierarchyOrgId),
    };
    var values = {
        policies: policies,
        trials: trials,
        enrollments: enrollments,
        features: features,
        user: user,
    };
    return (React.createElement("div", { className: "grid isBound" }, redirectError ? (React.createElement(Alert, { status: "info", size: "large" }, redirectError.message)) : (React.createElement(HDAccessProvider, { values: values },
        React.createElement("div", { className: "sui-w-screen sui-px-4 sm:sui-px-6" },
            React.createElement("div", { className: "sui-flex" },
                React.createElement("div", { className: "no-print sui-grid sui-gap-2 sui-p-3 sui-pl-0" },
                    React.createElement(Breadcrumbs, { routes: crumbs }),
                    React.createElement(Typography, { weight: "display", variant: "h1", uppercase: true }, pageTitle)),
                React.createElement("div", { className: "sui-hidden lg:sui-block sui-flex-grow", style: { paddingRight: 10 } }, headerComponent)),
            React.createElement("div", { className: "sui-grid sui-grid-flow-row sui-grid-cols-12 lg:sui-gap-4 sui-mt-6" },
                React.createElement("div", { className: "sui-col-span-12 lg:sui-col-span-3 " },
                    React.createElement(QueryProvider, { cacheKey: "customer-account-navigation" },
                        React.createElement(CustomerAccountNavigation, null))),
                React.createElement("div", { className: "sui-col-span-full lg:sui-col-span-9" }, children)))))));
};
